<!--
  @Description 历史问题查看
  @Date 2022-10-25
  @Author liufu
-->
<template>
  <vxe-modal
    v-model="isShow"
    size="mini"
    width="60%"
    height="80%"
    @show="showWindows"
    @close="closeWindows"
    :mask="false"
    show-zoom
  >
    <!-- 标题 -->
    <template #title>
      <!-- 问题编号 -->
      <span style="color: #888888">{{ form.num || '新增问题' }}</span>
      <!-- 模块名称 -->
      <span style="margin-left: 10px">{{ `[${form.groupName}]` }}</span>
      <!-- 页面名称 -->
      <span style="margin-left: 5px">{{ form.vuePath }}</span>
    </template>

    <!-- 编辑区域 -->
    <div class="edit-dv">
      <el-form :model="form" ref="FormRef" :validate-on-rule-change="false" :rules="rules" size="small">
        <!-- 第一行 -->
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="模块" prop="groupName">
              <el-input
                v-model="form.groupName"
                autocomplete="off"
                :placeholder="placeholderConfig.relation"
                :disabled="true"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6"
            ><el-form-item label="系统版本" prop="productionVersion">
              <el-input
                v-model="form.productionVersion"
                autocomplete="off"
                :placeholder="placeholderConfig.relation"
                :disabled="true"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6"
            ><el-form-item label="当前节点" prop="result">
              <el-input
                v-model="form.result"
                autocomplete="off"
                :placeholder="placeholderConfig.relation"
                :disabled="true"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="说明类型" prop="result">
              <el-select clearable v-model="form.result" :placeholder="placeholderConfig.select" :disabled="true">
                <el-option
                  :index="item + ''"
                  v-for="item in combobox.result"
                  :key="item.name"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第二行 -->
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="前端研发" prop="frontEngineer">
              <el-select
                clearable
                filterable
                v-model="form.frontEngineer"
                size="small"
                placeholder="选择前端人员"
                :disabled="true"
              >
                <el-option
                  v-for="i of selectOptions.frontEngineer"
                  :key="i.name + ''"
                  :label="i.name"
                  :value="i.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6"
            ><el-form-item label="后端研发" prop="backEngineer">
              <el-select
                clearable
                filterable
                v-model="form.backEngineer"
                size="small"
                placeholder="选择后端人员"
                :disabled="true"
              >
                <el-option
                  v-for="i of selectOptions.backEngineer"
                  :key="i.name + ''"
                  :label="i.name"
                  :value="i.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6"
            ><el-form-item label="技术测试" prop="techTester">
              <el-select
                clearable
                filterable
                v-model="form.techTester"
                size="small"
                placeholder="选择技术测试"
                :disabled="true"
              >
                <el-option
                  v-for="i of selectOptions.techTester"
                  :key="i.name + ''"
                  :label="i.name"
                  :value="i.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务测试" prop="businessTester">
              <el-select
                clearable
                filterable
                v-model="form.businessTester"
                size="small"
                placeholder="选择业务测试"
                :disabled="true"
              >
                <el-option
                  v-for="i of selectOptions.businessTester"
                  :key="i.name + ''"
                  :label="i.name"
                  :value="i.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第三行 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="问题内容" prop="content">
              <el-input
                type="textarea"
                :rows="8"
                v-model="form.content"
                autocomplete="off"
                :placeholder="placeholderConfig.relation"
                :disabled="false"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 间隔槽（内含保存按钮） -->
    <div class="gap-dv">
      <button class="btn add-btn" @click="handleTypography">
        排版问题内容
      </button>
    </div>

    <!-- 历史说明区域 -->
    <div class="history-dv">
      <div class="history-title">历史说明</div>
      <div class="history-list-dv">
        <div class="history-list-item" v-for="(item, index) of historyInsList" :key="index">
          <!-- 格式化成：'1. [2021-11-20 08:20 提出] 张三：说明内容' -->
          <span style="color: #6c9eff">{{ `${index + 1}. ` }}</span>
          <span style="color: #999">{{ `[${item.date} ${item.type}] ` }}</span>
          <span style="color: #101010; font-weight: bold">{{ `${item.user}：` }}</span>
          <span>{{ item.instruction }}</span>
        </div>
      </div>
    </div>
  </vxe-modal>
</template>

<script>
export default {
  name: 'HistoryQuestionShow',
  components: {},
  props: {
    parentObj: Object,
    // 当前数据行id
    id: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      // 弹窗是否打开
      isShow: false,
      form: {},
      // 当前页的所有行（用于上一条、下一条）
      curPageRowData: [],
      rules: {},
      // 特殊权限
      spcial: false,
      frontEngineerCache: '',
      backEngineerCache: '',
      techTesterCache: '',
      businessTesterCache: '',
      // 下拉框列表
      combobox: {
        // 说明类型
        result: []
      },
      // 历史说明列表
      historyInsList: [
        // {
        //   type: '提出',
        //   date: '2021-12-20 08:28',
        //   user: '张三',
        //   instruction: '前端处理人修改为李四'
        // },
      ],
      selectOptions: {
        frontEngineer: [],
        backEngineer: [],
        techTester: [],
        businessTester: []
      }
    }
  },
  methods: {
    // 排版问题内容
    handleTypography() {
      if (this.form.content) {
        let cache = this.form.content + ''
        const separator = cache.substring(1, 2)
        const re = new RegExp('([0-9]{1,3}|1000)' + '\\' + separator, 'g')
        const numList = cache.match(re)
        let resultList = []
        if (numList) {
          for (let i = 0; i < numList.length; i++) {
            // numList[i] = Number(String(numList[i]).split(separator)[0])
            if (i === 0) {
              resultList.push(numList[i])
            } else {
              if (
                Number(numList[i].split(separator)[0]) - 1 ===
                Number(resultList[resultList.length - 1].split(separator)[0])
              ) {
                resultList.push(numList[i])
              }
            }
          }
          // resultList = resultList.map(item => {
          //   return String(item) + separator
          // })
          if (resultList) {
            let isFirst = true
            for (let item of resultList) {
              if (isFirst) {
                isFirst = false
              } else {
                cache = cache.replace(item, '\n' + item)
              }
            }
            this.form.content = cache
          } else {
            this.$message.error('没有内容可以排版')
          }
        } else {
          this.$message.error('没有内容可以排版')
        }
      }
    },
    // 监听模态框开启
    async showWindows() {
      // 0107暂时不开启 this.setFormRules()
      // 获取人员下拉框
      // 0107暂时不开启 await this.getPerson()
      // 将刚打开弹窗时的所有人员作为缓存存起来，作为后续判断依据
      // 0107暂时不开启 this.setPersonCache()
    },
    // 监听模态框关闭
    closeWindows() {
      this.$refs['FormRef'].resetFields()
    },
    openModal() {
      this.isShow = true
    },
    closeModal() {
      this.isShow = false
    },
    // 赋值历史说明
    setHistoryInsList(form) {
      // form.comment 说明
      const comment = form.comment
      this.historyInsList = this.formatContentWrap(comment)
    },
    /**
     * @description 格式化说明
     * @param {String} comment 说明内容
     * @returns Array[{type, date, user, instruction}]
     */
    formatContentWrap(comment) {
      let res = []
      if (comment == null || comment.trim() === '') {
        return res
      }
      // 1.按句分割
      let sentence = comment.split('!#!')
      sentence.forEach(v => {
        // 2.按字段分割，[0]:类型  [1]:日期 [2]:人名  [3]:说明  [4]:问题说明id
        const word = v.split('!&!')
        const temp = {
          type: word[0] || '无',
          date: word[1] || '无',
          user: word[2] || '无',
          instruction: word[3] || '无'
        }
        if (this.$store.state?.systemSetting?.explainSort && this.$store.state.systemSetting.explainSort === 'asc') {
          res.unshift(temp)
        } else {
          res.push(temp)
        }
      })
      return res
    }
  },
  computed: {
    tableHeight() {
      if (this.approveDisplay) {
        return '225px'
      } else {
        return '100px'
      }
    },
    // 当前登录用户名
    curUserName() {
      return this.$store.state.userInfo.userName
    },
    // 当前行所在的索引（仅在当前分页数据内，用于上一条、下一条）
    curRowPosition() {
      return this.curPageRowData.findIndex(row => {
        return row.id === this.form.id
      })
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.setHistoryInsList(newVal)
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
@history-dv-height: 200px;
@all-dv-width: 98%;
// 编辑说明和历史说明之间的间隔
@dv-margin: 10px;
// 间隔槽总高度 = 高度 + margin
@gap-margin: 10px;
@gap-height: 30px;
@gap-padding-bottom: 10px;
.edit-dv {
  width: @all-dv-width;
  margin: 0 auto;
  height: calc(
    // dv-margin: 需要乘的数值 = 整体区块数量 + 1（如加了一个 gap-dv，则需要 + 1）
      100% - @history-dv-height - @dv-margin*4 - @gap-height - @gap-margin
  );
  overflow-y: scroll;
  overflow-x: hidden;
}

.edit-dv::-webkit-scrollbar {
  display: none;
}

.gap-dv {
  width: 100%;
  height: @gap-height;
  margin: @gap-margin 0;
  padding-bottom: @gap-padding-bottom;
  border-bottom: 1px solid #f2f3f5;
  .fl;

  .btn {
    margin: 0 10px;
    width: 180px;
    height: 30px;
    font-size: 14px;
    border-radius: 5px;
    outline: none;
    border: none;
    transition: @normal-transition;
  }

  > button:hover {
    cursor: pointer;
    opacity: 0.7;
  }

  > button:active {
    opacity: 0.9;
  }

  .save-btn {
    background-color: @primary-color;
    color: @text-color;
  }

  .add-btn {
    width: 100px;
    color: #666;
  }

  .del-btn {
    width: 100px;
    background-color: #ff8b8b;
    color: #fff;
  }

  .pre-next-btn {
    width: 70px;
  }
}

.btn-dv-prohibit {
  // cursor: not-allowed;
  transition: none !important;
  opacity: 0.5 !important;
  // color: #c0c4cc;
  // border-color: #ebeef5;
  // background-color: #f2f3f5;
}
.btn-dv-prohibit:hover {
  cursor: not-allowed !important;
  opacity: 0.5 !important;
}

.history-dv {
  width: @all-dv-width;
  height: @history-dv-height;
  margin: 10px auto;
  // background-color: #ffcc66;
  overflow-y: scroll;
  box-sizing: border-box;
  font-size: 14px;

  .scrollbar-mixin();

  .history-title {
    font-size: 16px;
    font-weight: bold;
    color: @able-color;
  }

  .history-list-dv {
    width: 97%;
    padding: @dv-margin auto;

    .history-list-item {
      margin: 6px 0;
    }
  }
}

.el-row {
  margin-bottom: 12px !important;
}
</style>
